<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-button variant="primary" @click="addSpacePlanClicked">
          {{ $t('add-vizualization') | capitalize }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import eventBus from '@/components/utils/slideout-panel/eventBus';

export default {
  name: 'Spaceplan',
  mixins: [
    BaseContextMenuMixin,
  ],
  methods: {
    addSpacePlanClicked() {
      eventBus.$emit('addSpacePlanClicked');
    },
  },
};
</script>

<style scoped>

</style>
